import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import { InfoIcon, OnHold, TimerText } from './UnlockTimer.styles';

function UnlockTimer({ className = '', inverted = false }) {
  const { setLockTimerModalOpen } = useContext(ModalContext);
  const { shouldShowTimer, timeLeftAsString } = useContext(UnlockTimerContext);

  return shouldShowTimer ? (
    <div className={`flex ${className}`}>
      <div className="flex-1">
        <OnHold inverted={inverted}>On Hold</OnHold>
        <TimerText inverted={inverted}>{timeLeftAsString}</TimerText>
      </div>
      <Clickable
        height={13}
        width={13}
        element={InfoIcon}
        className={inverted ? 'text-white' : 'text-grey-3'}
        onClick={() => setLockTimerModalOpen(true)}
        data-analytics-id="Unlock Timer - Info Icon"
      />
    </div>
  ) : null;
}

export default UnlockTimer;
